import configs from "./configs";
import getAuthUser from "./get-auth-user";

export default async function userHasTicket(ticketId, store) {
  const url = configs["NFT_MARKETPLACE_URL"] + "/api/tickets/check";
  const authUser = await getAuthUser(store, true);
  const address = authUser?.public_address;

  if (!address) {
    return false;
  }

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        address,
        ticketId
      })
    }).catch(() => {
      return false;
    });

    if (!response.ok) {
      return false;
    }

    const data = await response.json();

    return data?.hasNft;
  } catch (err) {
    return false;
  }
}
